<template>
    <div>
        <el-dialog
                title="Archive? (DANGER!)"
                :visible.sync="showArchive">
            <div>
                <p>WARNING! This is NOT REVERSIBLE!</p>
                <p>Are you sure you want to archive this extent?</p>
                <el-button v-on:click="reallyArchive()" type="danger">Yes, really archive this extent.</el-button>
                <el-button v-on:click="hideConfirmCancel()" type="success">Oops. Actually, keep processing.</el-button>
            </div>
        </el-dialog>
        <p v-if="!client_being_edited">Content Chimera is set up for you to analyze the digital presences of multiple clients.
        Just managing for your own organization? You can enter your own organization name below.</p>
        <p v-else>You can edit a client organization's name and the billing account here.</p>
        <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="Client's Organization Name" prop="name">
                <el-input placeholder="Enter your client's organization name" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item v-if="!client_being_edited" label="Site Name" prop="site">
                <el-input placeholder="Enter site name (if org only has one site, could also be the org name)" v-model="form.site"></el-input>
            </el-form-item>
            <el-form-item v-if="!client_being_edited"  label="Site URL (if you crawl, this will be the starting URL)" prop="url">
                <el-input placeholder="Enter URL of site" v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="Billing Account" prop="org_id">
                    <el-popover
                            placement="top-start"
                            title="Billing Account"
                            width="500"
                            trigger="hover"
                            content="Each account has a maximum number of URLs.
                                As URLs are imported or crawled into Content Chimera, these are deducted from the balance for that billing account.
                                You may have multiple billing accounts. Select the billing account you want to use for this new client.
            "
                    >
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                    <el-select filterable style="padding-left:10px;width:500px;" v-model="form.org_id" placeholder="Select">
                        <el-option
                                v-for="field in organizations"
                                :key="field.id"
                                :label="field.name + ' (' + field.discover_urls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' out of ' + field.max_discover_urls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' remaining)'"
                                :value="field.id">
                        </el-option>
                    </el-select>
            </el-form-item>
            <div>
                <el-button v-if="!client_being_edited" type="primary" style="margin-top:20px" v-on:click="addTenant">Add New</el-button>
                <el-button v-else type="primary" style="margin-top:20px" v-on:click="saveTenant">Save Changes</el-button>
                <span v-if="client_being_edited">
                  <el-button v-if="client_being_edited.state=='active'" @click="archive" type="danger" plain>Archive</el-button>
                  <span v-else style="margin-left:20px">Already {{client_being_edited.state}}</span>

                </span>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        mounted() {
            axios.get('/api/organizations')
                .then(response => {
                    this.organizations = response.data
                    if (this.can_add) {
                        // console.log(this.extents)
                        this.form.org_id = this.organizations[0].id
                    } else {
                        this.form.name = this.client_being_edited.name
                        this.form.org_id = this.client_being_edited.org_id
                    }
                })
                .catch(error => {
                    console.log('oops getting organizations list')
                })
        },
        props: ['user_id','client_being_edited','can_add'],
        watch: {
            client_being_edited: function (value) {
                console.log('client_being_edited')
                console.log(value)
                if (value) {
                    this.form.name = value.name
                    this.form.org_id = value.org_id
                } else {
                    this.form.name = null
                    this.form.org_id = null
                }
            },
        },
        data() {
            return {
                form: {
                    name: null,
                    site: null,
                    url: null,
                    org_id: null,
                },
                rules: {
                    name: [
                        {required: true, message: 'Please enter your client\'s organization name', trigger: 'submit'}
                    ],
                    site: [
                        {required: true, message: 'Please enter your client\'s site name', trigger: 'submit'}
                    ],
                    url: [
                        {type: 'url', required: true, message: 'Please enter your client\'s site\'s URL', trigger: 'submt'}
                    ],
                    org_id: [
                        {required: true, message: 'Please select the billing account (the account from which the URL bank will be deducted', trigger: 'submit'}
                    ]
                },
                organizations: null,
                showArchive: false,
            }
        },
        methods: {
            archive() {
                this.showArchive = true
            },
            hideConfirmCancel() {
                this.showArchive = false
            },
            reallyArchive() {
                axios.delete('/extents/' + this.client_being_edited.id)
                .then(response => {
                    console.log('finished deleting')
                    this.$emit('updateTenant')
                    this.showArchive = false
                }).catch(error => {
                    console.log(error.response)
                    this.showArchive = false
                });
            },
          saveTenant() {
              let errors = false
              this.$refs['form'].validate((valid) => {
                  if (!valid) {
                      errors = true
                  }
              });
              if (errors) {
                  return false;
              }
              axios.post('/api/tenants', {
                  name: this.form.name,
                  organization_id: this.form.org_id,
                  id: this.client_being_edited.id
              }).then(response => {
                  console.log(response)
                  console.log('finished saving the tenant')
                  this.$emit('updateTenant')
              }).catch(error => {
                  console.log(error.response)
              });
          },
          addTenant() {
              let errors = false
              this.$refs['form'].validate((valid) => {
                  if (!valid) {
                      errors = true
                  }
              });
              if (errors) {
                  return false;
              }
              console.log('In addTenant.')
              console.log(this.form.site)
              console.log(this.form.org_id)
              axios.post('/api/tenants', {
                  name: this.form.name,
                  site: this.form.site,
                  url: this.form.url,
                  user_id: this.user_id,
                  org_id: this.form.org_id
              }).then(response => {
                  console.log(response)
                  console.log('finished adding the tenant')
                  axios.post('/extents/current', {
                      current_extent: response.data.id
                  }).then(response => {
                      console.log(response)
                      console.log('set the extent session variable')
                      window.location.href = '/assets'
                  })
                      .catch(error => {
                          console.log('could not set the extent session variable')
                      })
              }).catch(error => {
                  console.log(error.response)
              });

          }
        }
    }
</script>